import React from 'react';
import { tableStyles } from '../../styles/tailwind.classes';

const TableHeader = ({ children, sortable = false, sorted = false, sortDirection = 'asc', onClick }) => {
  return (
    <th
      onClick={onClick}
      className={`${tableStyles.headerCell} ${
        sortable ? 'cursor-pointer hover:bg-gray-100' : ''
      }`}
    >
      <div className="flex items-center space-x-2">
        <span>{children}</span>
        {sortable && (
          <span className="text-gray-400">
            {sorted ? (
              sortDirection === 'asc' ? '↑' : '↓'
            ) : '↕'}
          </span>
        )}
      </div>
    </th>
  );
};

export default TableHeader; 